import React from "react";
import { motion } from "framer-motion";
import { sectionVariants, staggerContainer } from "../../constants/animations";
import SkillBar from "../SkillBar";
import TechIcon from "../TechIcon";
import {
  LANGUAGES_FRAMEWORKS,
  CLOUD_DEVOPS,
  DATABASES,
  TECH_ICONS,
} from "./TechnicalSkills.constants";

const TechnicalSkills: React.FC = () => {
  return (
    <motion.section
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="py-20 px-6 bg-slate-800/30"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-bold mb-12 text-center gradient-text">
          Technical Skills
        </h2>

        {/* Programming Languages & Frameworks */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold mb-6 text-blue-400">
            Languages & Frameworks
          </h3>
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid gap-4"
          >
            {LANGUAGES_FRAMEWORKS.map((skill) => (
              <SkillBar
                key={skill.name}
                name={skill.name}
                level={skill.level}
                color={skill.color}
                icon={<skill.icon />}
                delay={skill.delay}
              />
            ))}
          </motion.div>
        </div>

        {/* Cloud & DevOps */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold mb-6 text-purple-400">
            Cloud & DevOps
          </h3>
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid gap-4"
          >
            {CLOUD_DEVOPS.map((skill) => (
              <SkillBar
                key={skill.name}
                name={skill.name}
                level={skill.level}
                color={skill.color}
                icon={<skill.icon />}
                delay={skill.delay}
              />
            ))}
          </motion.div>
        </div>

        {/* Databases & Storage */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold mb-6 text-pink-400">
            Databases & Storage
          </h3>
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid gap-4"
          >
            {DATABASES.map((skill) => (
              <SkillBar
                key={skill.name}
                name={skill.name}
                level={skill.level}
                color={skill.color}
                icon={<skill.icon />}
                delay={skill.delay}
              />
            ))}
          </motion.div>
        </div>

        {/* Tech Icons Grid */}
        <div className="mt-12">
          <h3 className="text-2xl font-bold mb-6 text-center text-slate-300">
            Full Technology Stack
          </h3>
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="flex flex-wrap justify-center gap-6"
          >
            {TECH_ICONS.map((tech) => (
              <TechIcon key={tech.label} delay={tech.delay} label={tech.label}>
                <tech.icon />
              </TechIcon>
            ))}
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default TechnicalSkills;
